import ServiceTemplate from '../ServiceTemplate';

const LoanConsolidation = () => {
  const serviceData = {
    title: 'איחוד הלוואות',
    description: 'איחוד כל ההלוואות שלכם למשכנתא אחת עם החזר חודשי נוח יותר ותנאים משופרים, תוך הקטנת העומס הכלכלי והפחתת ההוצאות החודשיות.',
    sections: [
      {
        title: 'למה כדאי לאחד הלוואות?',
        content: 'איחוד הלוואות מאפשר לכם לנהל את כל ההתחייבויות הכספיות שלכם תחת קורת גג אחת, עם החזר חודשי אחד ובתנאים טובים יותר. במקום להתמודד עם מספר הלוואות בריביות גבוהות, תוכלו ליהנות מריבית נמוכה יותר ומהחזר חודשי נוח יותר.'
      },
      {
        title: 'איך התהליך עובד?',
        content: 'נתחיל בסקירה מקיפה של כל ההלוואות הקיימות שלכם. נבחן את התנאים, הריביות והעלויות של כל הלוואה. לאחר מכן, נבנה תכנית לאיחוד ההלוואות באופן שיביא לחיסכון מקסימלי ויקל על ההתנהלות הכספית השוטפת שלכם.'
      }
    ],
    benefits: [
      'הקטנת ההחזר החודשי הכולל',
      'ריבית נמוכה יותר על ההלוואות',
      'התנהלות פיננסית פשוטה יותר',
      'שיפור תזרים המזומנים',
      'חיסכון בעלויות הכוללות',
      'פריסת תשלומים נוחה יותר'
    ],
    faqs: [
      {
        question: 'אילו הלוואות ניתן לאחד?',
        answer: 'ניתן לאחד מגוון רחב של הלוואות: הלוואות אישיות, הלוואות רכב, אשראי בכרטיסי אשראי, הלוואות עסקיות ועוד. נבחן כל מקרה לגופו ונמליץ על איחוד ההלוואות שיביא לחיסכון המשמעותי ביותר.'
      },
      {
        question: 'האם איחוד הלוואות תמיד משתלם?',
        answer: 'לא תמיד. נבצע ניתוח מקיף של כל ההלוואות הקיימות, כולל עמלות פירעון מוקדם ועלויות נלוות, ונמליץ על איחוד רק אם הוא באמת משתלם עבורכם. לעתים, איחוד חלקי או השארת חלק מההלוואות במתכונתן הנוכחית יכול להיות הפתרון המיטבי.'
      },
      {
        question: 'האם איחוד הלוואות יכול לפגוע בדירוג האשראי?',
        answer: 'בטווח הקצר, כל בקשת אשראי חדשה יכולה להשפיע מעט על דירוג האשראי. אולם, בטווח הארוך, איחוד הלוואות מוצלח שמביא להתנהלות פיננסית טובה יותר יכול דווקא לשפר את דירוג האשראי שלכם.'
      },
      {
        question: 'כמה זמן לוקח תהליך איחוד הלוואות?',
        answer: 'התהליך בדרך כלל אורך בין שבועיים לחודש, תלוי במספר ומורכבות ההלוואות שרוצים לאחד. אנחנו נלווה אתכם בכל השלבים, מהבדיקה הראשונית ועד לביצוע האיחוד בפועל.'
      },
      {
        question: 'האם יש מגבלות על סכום ההלוואות שניתן לאחד?',
        answer: 'הסכום המקסימלי תלוי במספר גורמים כמו שווי הנכס המשועבד, יכולת ההחזר שלכם, והמדיניות של הבנק המממן. אנחנו נבחן את המצב שלכם ונמצא את הפתרון האופטימלי במסגרת המגבלות הקיימות.'
      }
    ],
    whatsappMessage: 'שלום, אני מתעניין/ת באיחוד הלוואות ואשמח לקבל מידע נוסף.'
  };

  return <ServiceTemplate {...serviceData} />;
};

export default LoanConsolidation; 